export const CustomerRoleEnum =
[
    {
        "id": "ROLE_USER",
        "name": "Customer",
        "disabled": true
    },
    {
        "id": "ROLE_EMPLOYEE",
        "name": "Employee"
    },
    {
        "id": "ROLE_SALES_REPRESENTATIVE",
        "name": "Representative"
    },
    {
        "id": "ROLE_PROFESSIONAL",
        "name": "Professional"
    }
];

export const AdminRoleEnum =
[
    {
        "id": "ROLE_ADMIN",
        "name": "Admin"
    },
    {
        "id": "ROLE_ADMIN_SALES",
        "name": "Sales Manager"
    },
    {
        "id": "ROLE_ADMIN_MARKETING",
        "name": "Marketing Manager"
    },
    {
        "id": "ROLE_ADMIN_INVERTORY",
        "name": "Inventory Manager"
    },
    {
        "id": "ROLE_ADMIN_SAMPLING",
        "name": "Sampling Manager"
    },
    {
        "id": "ROLE_ADMIN_CUSTOMER",
        "name": "Customer Manager"
    },
];

export const RoleEnum = [...CustomerRoleEnum, ...AdminRoleEnum];
